<template>
  <div>
    <v-header class="header"></v-header>
    <v-headers class="headers"></v-headers>
    <router-view></router-view>
    <v-footer></v-footer>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Headers from '@/components/herders.vue'
import Footer from '@/components/footer.vue'
// let isBosyuu = false;
export default {
  name: '',

  components: {
    'v-footer': Footer,
    'v-header': Header,
    'v-headers': Headers,
  },
  data: () => ({
    isBosyuu: false,
  }),
  created() {},
  mounted() {},
  watch: {},
  computed: {
    // comicsState() {
    //   return this.$store.state.comicsState;
    // },
  },
  beforeRouteUpdate(to, from, next) {
    // ...
    this.isBosyuu = to.fullPath === '/bosyuu' ? true : false
    next()
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.header {
  @media screen and (max-width: 600px) {
    display: none;
  }
}
.headers {
  display: none;
  @media screen and (max-width: 600px) {
    display: block;
  }
}
</style>
